/* eslint-disable react/no-multi-comp */
import { memo } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const namesRender = (names = []) => {
	if (names.length === 1) {
		return (
			<ul className="amenity__items" data-testid="amenity-items">
				<li className="amenity__item">
					<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>{names[0]}</Typography>
				</li>
			</ul>
		);
	}
	const midpoint = Math.ceil(names.length / 2);
	return (
		<div className="amenity__items" data-testid="amenity-items">
			{[names.slice(0, midpoint), names.slice(midpoint)].map((list, index) => (
				<ul className="amenity__items-list" key={index}>
					{list.map(item => (
						<li key={item} className="amenity__item">
							<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>{item}</Typography>
						</li>
					))}
				</ul>
			))}
		</div>
	);
};

const Amenity = ({ headline, names = [] }) => {
	if (!headline && names.length === 0) {
		return false;
	}

	return (
		<div className="amenity" data-testid="amenity">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="amenity__title"
					data-testid="amenity-title"
				>
					{headline}
				</Typography>
			)}
			{names.length > 0 && namesRender(names)}
		</div>
	);
};

Amenity.propTypes = {
	headline: PropTypes.string,
	names: PropTypes.arrayOf(PropTypes.string),
};

export default memo(Amenity);
